import { Component } from '@angular/core';
import { ReportingBoardComponent } from '../employees/reporting-board/reporting-board';

@Component({
  selector: 'app-admin-reporting-view',
  standalone: true,
  imports: [ReportingBoardComponent],
  template: `
    <app-reporting-board />
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class AdminReportingView {}

